export default {
    "delete-message-mission": "هل أنت متأكد أنك تريد حذف هذه المهمة؟"
}